import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SettingsFooter } from "../components/SettingsFooter";
import { NotificationCategorySection } from "../notifications/sections/NotificationCategorySection";
import { useNotifications } from "../notifications/hooks/use-notifications";
import {
  useSettingsFormState,
  useSettingsLoading,
} from "../store/settings-store";
import { ConsentSection } from "./sections/ConsentSection";
import { ShakePermissionSection } from "./sections/ShakePermissionSection";

export const PermissionsTab: React.FC = () => {
  const { t } = useTranslation();
  const { setHasUnsavedChanges, markAsSaved, hasUnsavedChanges } =
    useSettingsFormState("permissions");
  const { isLoading: settingsLoading } = useSettingsLoading("permissions");

  // Notifications hook - handles all state and actions
  const {
    hasChanges,
    handleSave,
    handleCancel,
    isLoading: notificationsLoading,
  } = useNotifications();

  // Track changes
  useEffect(() => {
    setHasUnsavedChanges(hasChanges);
  }, [hasChanges, setHasUnsavedChanges]);

  const onSave = async () => {
    await handleSave();
    markAsSaved();
  };

  const onCancel = () => {
    handleCancel();
    markAsSaved();
  };

  return (
    <div className="flex flex-col gap-8">
      {/* Permissions Section Header */}
      <div className="flex flex-col gap-5">
        <div>
          <h3 className="text-lg font-semibold text-text-primary dark:text-text-primary mb-2">
            {t("settings.permissions.title")}
          </h3>
          <p className="text-sm text-text-tertiary dark:text-text-tertiary">
            {t("settings.permissions.description")}
          </p>
        </div>
        <div className="h-px bg-border-secondary dark:bg-border-secondary" />
      </div>

      {/* Device Permissions */}
      <ShakePermissionSection />

      <div className="h-px bg-border-secondary dark:bg-border-secondary" />

      {/* Çerez tercihi — rıza geri alınabilir olmak zorunda */}
      <ConsentSection />

      <div className="h-px bg-border-secondary dark:bg-border-secondary" />

      {/* Notification Preferences (existing feature) */}
      <div className="flex flex-col gap-5">
        <div>
          <h3 className="text-lg font-semibold text-text-primary dark:text-text-primary mb-2">
            {t("settings.notifications.notificationSettings")}
          </h3>
          <p className="text-sm text-text-tertiary dark:text-text-tertiary">
            {t("settings.notifications.notificationSettingsDescription")}
          </p>
        </div>
        <div className="h-px bg-border-secondary dark:bg-border-secondary" />
      </div>

      <NotificationCategorySection />

      {/* Footer Actions */}
      <SettingsFooter
        onSave={onSave}
        onCancel={onCancel}
        isLoading={settingsLoading || notificationsLoading}
        disabled={!hasUnsavedChanges}
      />
    </div>
  );
};


